export interface TPAComponentsConfig {
  mobile?: boolean;
  rtl?: boolean;
  seo?: boolean;
  cssVars?: boolean;
  isExtendedPaletteEnabled?: boolean;
  _setIsExtendedPaletteEnabledState?: (enabled: boolean) => void;
}

export interface TPAComponentsProviderProps {
  value: TPAComponentsConfig;
  children: React.ReactNode;
  dataHook?: string;
  as?: 'div' | 'span';
}
